// extracted by mini-css-extract-plugin
module.exports = {"main":"mobile-module__main___+TgiY","back":"mobile-module__back___hBBET","svg":"mobile-module__svg___BWgD+","wraper":"mobile-module__wraper___RQzw7"};